import { useContext } from "react";
import { AppContext } from "../App";
import { FiLayers, FiCpu, FiActivity } from "react-icons/fi";

export default function DiagnosticServices() {
  const appContext = useContext(AppContext);

  const services = [
    {
      icon: <FiLayers />,
      title: "Advanced Laboratory Services",
      desc: "Full-service clinical diagnostics across Hematology, Clinical Chemistry, Microbiology, Parasitology, Serology, Immunology, Hormonal profiling, and Point-of-Care testing."
    },
    {
      icon: <FiCpu />,
      title: "Radiology & Diagnostic Imaging",
      desc: "High-resolution digital diagnostic X-ray and ultrasound services under full TAEC radiation safety certification, ALARA guidelines, and rigorous MRIPC oversight."
    },
    {
      icon: <FiActivity />,
      title: "Electrocardiogram & Cardiac Monitoring",
      desc: "Resting 12-lead electrocardiography (ECG) and baseline cardiac rhythm monitoring integrated smoothly with the Non-Communicable Disease (NCD) clinic workflows."
    }
  ];

  return (
    <div className="pillar-container">
      <div className="pillar-header">
        <h2 className="pillar-title">Diagnostic Services</h2>
        <p className="pillar-subtitle">Precision, data-driven diagnostic systems meeting high domestic regulatory safety frameworks.</p>
      </div>

      <div className="pillar-grid">
        {services.map((item, idx) => (
          <div 
            key={idx} 
            className="pillar-card"
            onClick={() => appContext.navTo({ item: "contact_us"})}
          >
            <div className="pillar-icon">{item.icon}</div>
            <h3 className="pillar-card-title">{item.title}</h3>
            <p className="pillar-card-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}